module.exports = __webpack_public_path__ + "img/EffluentTeeFilter.dfa14556.jpeg";